import { SELECT_PRODUCTS_BASED_ON_ALL, SELECT_PRODUCTS_BASED_ON_TAGS } from "../../constants/selectProductsBasedOn.js";

export const getHeaderText = (selectProductsBasedOn) => {
    switch (selectProductsBasedOn) {
        case SELECT_PRODUCTS_BASED_ON_TAGS:
            return "Tags selection";
        case SELECT_PRODUCTS_BASED_ON_ALL:
            return "Product targeted";
        default:
            return "Add collections and products";
    }
};

export const getSubtitleText = (selectProductsBasedOn) => {
    switch (selectProductsBasedOn) {
        case SELECT_PRODUCTS_BASED_ON_TAGS:
            return "First, pick a selection logic and then the tags you want to select or exclude from your action.";
        case SELECT_PRODUCTS_BASED_ON_ALL:
            return "You have selected all products in your shop. Stockhide will run an action to all of these products.";
        default:
            return "Pick products or collections individually or use our wide range of filters.";
    }
};